<template>
    <div>
        <div id="details-view" v-if="showModal" ref="detailsWrapper" :class="{'is-scrolling': scrolling}">
            <header class="top-header row d-block d-md-none" :class="{'is-scrolling': scrolling}">
                <div class="logo" :class="{'col-md-2': scrolling,'col-md-4': !scrolling}">
                    <a class="off-scroll" href="https://fashionheritage.eu" id="logo">European Fashion Heritage
                        Association</a>
                    <a class="on-scroll" href="https://fashionheritage.eu" id="logo-small">European Fashion Heritage
                        Association</a>
                </div>
            </header>

            <div v-if="!isFetching" class="scroll-container">
                <div id="sharer" class="d-none d-md-block">
                    <div class="socials socials-wrapper">
                        <a class="socials socials-facebook" :href="'https://www.facebook.com/share.php?u=' + pageUrl"
                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a class="socials socials-twitter"
                           :href="'https://twitter.com/share?' + 'url=' + pageUrl + '&text=' + title + '&via=eurfashion'"
                           onclick="javascript:window.open(this.href,'','menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a class="socials socials-pinterest"
                           :href="'https://pinterest.com/pin/create/button/?url=' + pageUrl + '&media=' + (images ? images[0] : null) + '&description=' + title + ' on ' + pageUrl"
                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;"><i
                                class="fab fa-pinterest-p"></i></a>
                        <a class="socials socials-linkedin"
                           :href="'https://www.linkedin.com/shareArticle?mini=true&url='  + pageUrl + '&source=fashionheritage.eu&title=' + title"
                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                            <i class="fab fa-linkedin"></i>
                        </a>

                    </div>
                </div>
                <button href="#" class="closer" @click="closeEvent">
                    <svg width="35" height="35" viewBox="0 0 35 35">
                        <g>
                            <path d="M0,0 l35,35"/>
                            <path d="M0,35 l35,-35"/>
                        </g>
                    </svg>
                </button>
                <div class="row header">
                    <div class="col-md-9 mx-auto">
                        <h1>{{title}}</h1>
                    </div>
                </div>
                <div class="row meta d-none d-md-block">
                    <div class="col-md-9 mx-auto">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="meta-description">
                                    <template v-if="description.length > 300">
                                        <span v-if="!moreTextShow" v-html="description.substr(0, 300)"></span>
                                        <span v-if="!moreTextShow" class="text-view-more"
                                              @click="moreText(true)">... [more]</span>
                                        <span :class="{'text-more': true, 'is-expanded': moreTextShow }">
                                        <span v-html="description"/>
                                        <span class="text-view-less" @click="moreText(false)">[less]</span>
                                    </span>
                                    </template>
                                    <template v-if="description.length <= 300">
                                        {{description}}
                                    </template>
                                </div>

                                <div class="sharer d-block d-md-none">
                                    <div class="socials socials-wrapper">
                                        <a class="socials socials-facebook"
                                           :href="'https://www.facebook.com/share.php?u=' + pageUrl"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                        <a class="socials socials-twitter"
                                           :href="'https://twitter.com/share?' + 'url=' + pageUrl + '&text=' + title + '&via=eurfashion'"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                        <a class="socials socials-pinterest"
                                           :href="'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(pageUrl) + '&media=' + (images ? encodeURIComponent(images[0]) : null) + '&description=' + encodeURIComponent(title + ' on ' + pageUrl)"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;"><i
                                                class="fab fa-pinterest-p"></i></a>
                                        <a class="socials socials-linkedin"
                                           :href="'https://www.linkedin.com/shareArticle?mini=true&url='  + pageUrl + '&source=fashionheritage.eu&title=' + title"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                                            <i class="fab fa-linkedin"></i>
                                        </a>

                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div v-if="meta" v-html="meta.all.join('')"></div>
                                <div class="spec spec-rights">
                                    <h4>Rights statement</h4>
                                    <div class="meta-identifier" v-if="meta" v-html="meta.rights"></div>
                                </div>
                                <span v-if="metaRowComplete" class="row-breaker"></span>
                                <div class="spec spec-provider"
                                     v-if="meta && meta.provider && meta.provider.length > 0">
                                    <h4>Content Provider</h4>
                                    <div class="meta-identifier" v-if="meta" v-html="meta.provider[1]"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row meta d-block d-md-none">
                    <div class="col-md-9 mx-auto">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="meta-description" v-html="description"></div>

                                <div class="sharer d-block d-md-none">
                                    <div class="socials socials-wrapper">
                                        <a class="socials socials-facebook"
                                           :href="'https://www.facebook.com/share.php?u=' + pageUrl"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                        <a class="socials socials-twitter"
                                           :href="'https://twitter.com/share?' + 'url=' + pageUrl + '&text=' + title + '&via=eurfashion'"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                        <a class="socials socials-pinterest"
                                           :href="'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(pageUrl) + '&media=' + (images ? encodeURIComponent(images[0]) : null) + '&description=' + encodeURIComponent(title + ' on ' + pageUrl)"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;"><i
                                                class="fab fa-pinterest-p"></i></a>
                                        <a class="socials socials-linkedin"
                                           :href="'https://www.linkedin.com/shareArticle?mini=true&url='  + pageUrl + '&source=fashionheritage.eu&title=' + title"
                                           onclick="javascript:window.open(this.href,'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;">
                                            <i class="fab fa-linkedin"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row media">
                    <div class="col-md-9 mx-auto text-center">
                        <carousel
                                :per-page="1"
                                :spacePadding="20"
                                :paginationEnabled="false"
                                :navigationEnabled="true"
                                :navigationPrevLabel="`<i class='fas fa-chevron-left'></i>`"
                                :navigationNextLabel="`<i class='fas fa-chevron-right'></i>`"
                        >
                            <slide
                                    v-for="image in images"
                                    :key="image"
                            >
                                <img
                                        :class="{'slide-image': true}"
                                        :src="image"
                                        @click="showModalGallery=true"
                                />
                            </slide>
                        </carousel>
                    </div>
                </div>
                <div class="row meta d-block d-md-none">
                    <div class="col-md-9 mx-auto">
                        <div class="row">
                            <div class="col-md-8">
                                <div v-if="meta" v-html="meta.all.join('')"></div>
                                <div class="spec spec-rights">
                                    <h4>Rights statement</h4>
                                    <div class="meta-identifier" v-if="meta" v-html="meta.rights"></div>
                                </div>
                                <span v-if="metaRowComplete" class="row-breaker"></span>
                                <div class="spec spec-provider"
                                     v-if="meta && meta.provider && meta.provider.length > 0">
                                    <h4>Content Provider</h4>
                                    <div class="meta-identifier" v-if="meta" v-html="meta.provider[1]"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isFetching">
                <div class="loading-placeholder">
                    Loading
                </div>
            </div>
        </div>
        <Modal
                v-if="meta && showModalGallery"
                :images="images"
                @closed="showModalGallery=false"
        />
    </div>
</template>

<script>
import axios from 'axios'
import {itemDetailsJSON, rightsImage} from '../helpers/ported'
import {Carousel, Slide} from 'vue-carousel'
import ArchiveItem from './ArchiveItem'
import Modal from './Modal'

export default {
  name: 'DetailsView',
  props: [
    'item',
    'close',
    'callback'
  ],
  data () {
    return {
      isFetching: false,
      loadedData: null,
      showModal: false,
      scrolling: false,
      moreTextShow: false,
      imagesErrors: [],
      images: [],
      window: {
        width: 0,
        height: 0
      },
      showModalGallery: false,
      imagesPreload: [],
      metaRowComplete: false
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: [
        {
          'property': 'og:title',
          'content': this.title,
          'template': chunk => `${chunk}`,
          'vmid': 'og:title'
        },
        {
          'property': 'og:description',
          'content': this.description.substr(0, 128).replace('<br/>', ''),
          'template': chunk => `${chunk}`,
          'vmid': 'og:description'
        },
        {
          'property': 'og:image',
          'content': !this.isFetching && this.meta && this.meta.media && this.meta.media.length > 0 ? this.meta.media[0].uri : null,
          'template': chunk => `${chunk}`,
          'vmid': 'og:image'
        }
      ]
      /*
    meta: [
      { vmid: 'description', name: 'description', content: this.description }
    ]
    */
    }
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        let vm = this
        if (newValue && oldValue !== newValue) {
          vm.showModal = true
          vm.fetchItem()
        }
      }
    },
    imagesErrors: {
      immediate: true,
      deep: true,
      handler () {
        setTimeout(() => {
          this.$forceUpdate()
        }, 500)
      }
    }
  },
  mounted: function () {
    let vm = this
    vm.loadedData = null
    vm.images = []
    if (vm.item) {
      vm.showModal = true
      vm.fetchItem()
    }

    setTimeout(() => {
      vm.$refs.detailsWrapper.addEventListener('scroll', this.handleScroll)
    }, 20)
  },
  components: {
    Carousel,
    Slide,
    ArchiveItem,
    Modal
  },
  asyncComputed: {
    meta: function () {
      let vm = this
      if (!vm.loadedData) {
        return null
      }

      let meta = {
        rights: null,
        all: []
      }

      let htmlstr = []
      let htmlstrN = 0
      const jsonData = itemDetailsJSON(vm.loadedData)

      jsonData.htmlstr.map(e => {
        htmlstr.push(e)
        if (htmlstrN++ % 2) {
          htmlstr.push('<span class="row-breaker"></span>')
        }
      })

      vm.metaRowComplete = htmlstrN++ % 2

      if (vm.loadedData) {
        const details = jsonData
        meta = {
          rights: vm.loadedData.edmrights.values.map(e => {
            const rights = rightsImage(e.uri)
            return rights.img
          }).join('<br/>'),
          all: htmlstr,
          media: details.media,
          pdf: details.pdfs,
          provider: details.divprovider,
          creator: details.itemcreator,
          similar: details.similar
        }

        const imagesPreload = details.media.map(e => {
          return new Promise((resolve, reject) => {
            const img = document.createElement('img')
            img.addEventListener('load', () => {
              resolve(e.uri)
            })
            img.addEventListener('error', () => {
              resolve(null)
            })
            img.setAttribute('src', e.uri)
          })
        })

        Promise.all(imagesPreload).then((e) => {
          vm.images = e.filter(e => e !== null)
        }).catch((e) => {
        })
      }

      return meta
    }
  },
  computed: {
    pageUrl: function () {
      return window.location.protocol + '//' + window.location.host + encodeURIComponent(this.$route.fullPath)
    },
    title: function () {
      let vm = this
      if (vm.loadedData && vm.loadedData.title && vm.loadedData.title.values && vm.loadedData.title.values[0]) {
        return vm.loadedData.title.values[0].text
      }

      return ''
    },
    description: function () { // @todo change to view
      let vm = this
      if (vm.loadedData && vm.loadedData.description && vm.loadedData.description.values) {
        return vm.loadedData.description.values.map(e => e.text).join('')
      }

      return ''
    }
  },
  beforeDestroy () {
    this.loadedData = null
    this.images = []
    this.$refs.detailsWrapper.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    next () {
      this.$refs.slick.next()
    },
    prev () {
      this.$refs.slick.prev()
    },
    moreText (state) {
      this.moreTextShow = state
    },
    clickEvent (event) {
      this.callback(event.id.substr(0, event.id.indexOf('#')))
    },
    handleResize () {
      let vm = this
      vm.window.width = window.innerWidth
      vm.window.height = window.innerHeight
    },
    handleScroll () {
      let vm = this
      vm.scrolling = vm.$refs.detailsWrapper.scrollTop > 0
    },
    closeEvent (event) {
      let vm = this
      vm.loadedData = null
      vm.showModal = false
      vm.close()
    },
    fetchItem () {
      let vm = this

      if (!vm.isFetching) {
        vm.isFetching = true
        axios.get('https://portal.fashionheritage.eu/api/record/' + vm.item)
          .then(result => {
            const data = result.data
            vm.isFetching = false
            vm.loadedData = data
          })
          .catch(err => {
            console.error(err)
            setTimeout(function () {
              vm.isFetching = false
              vm.loadedData = null
            }, 1000)
          })
      }
    }
  }
}
</script>

<style scoped>
    @import '_DetailsView.scss';

    .media .img-not-found {
        width: 200px;
        height: 200px;
    }

</style>



// WEBPACK FOOTER //
// src/components/DetailsView.vue